
export default class TransformOperation {
  constructor (parts) {
    this.translations = parts.map(p => {
      return {
        part: p,
        fromPosition: {
          x: p.prevPosition.x,
          y: p.prevPosition.y
        },
        toPosition: {
          x: p.position.x,
          y: p.position.y
        },
        fromRotation: p.prevRotation,
        toRotation: p.rotation
      };
    });
  }

  opType () {
    return 'transform';
  }

  redo (root) {
    this.translations.forEach(tr => {
      tr.part.moveTo(tr.toPosition.x, tr.toPosition.y);
      tr.part.rotateTo(tr.toRotation);
    });
  }

  undo (root) {
    this.translations.forEach(tr => {
      tr.part.moveTo(tr.fromPosition.x, tr.fromPosition.y);
      tr.part.rotateTo(tr.fromRotation);
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/nesting/operations/transform_operation.js